import React, { ReactNode, useCallback } from 'react';
import cx from 'classnames';
import s from './BButtonGroup.module.scss';
import { BButtonProps } from '../BButton';

type ButtonGroupVariant = 'text' | 'contained' | 'outlined';
type ButtonGroupSize = 'sm' | 'm';
type ButtonGroupColor = 'primary' | 'secondary' | 'info' | 'warn' | 'error' | 'dark';

export interface BButtonGroupProps {
  className?: string;
  variant?: ButtonGroupVariant;
  size?: ButtonGroupSize;
  color?: ButtonGroupColor;
  children: ReactNode;
}

export const BButtonGroup = (props: BButtonGroupProps) => {
  const {
    className,
    variant = 'contained',
    color = 'primary',
    size = 'sm',
    children,
  } = props;

  const additional = [
    s[variant],
    className,
  ];

  const childrenWithProps = useCallback(() => React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React
        .cloneElement(
            child as React.ReactElement<BButtonProps>,
            {
              variant, color, size, ...child.props,
            },
        );
    }

    return child;
  }), [children, variant, color, size]);

  return (
    <div className={cx(s.feButtonGroup, additional)}>
      {childrenWithProps()}
    </div>
  );
};
